/* ============
 * Getters for the formalities module
 * ============
 *
 * The getters that are available on the
 * formalities module.
 */

export default {
  onboarding: state => { return state.onboarding },
  possibility: state => { return state.possibility }
}



// WEBPACK FOOTER //
// ./src/store/modules/loans/getters.js